__turbopack_context__.v({
  "closeButton": "modal-module__09A2QG__closeButton",
  "content": "modal-module__09A2QG__content",
  "fadeIn": "modal-module__09A2QG__fadeIn",
  "header": "modal-module__09A2QG__header",
  "modal": "modal-module__09A2QG__modal",
  "overlay": "modal-module__09A2QG__overlay",
  "slideUp": "modal-module__09A2QG__slideUp",
  "title": "modal-module__09A2QG__title",
});
